import React, { Component } from 'react';
import I18n from '~/utils/translations';
import IconBeds from '~/images/icon-bed.svg';
import IconSqft from '~/images/icon-ruler.svg';
import IconZone from '~/images/homes/zone.svg';

export default class ListingFeatures extends Component {
  selectFeatureIconClass = (type) => {
    let options = {
      beds: 'bed',
      sqft: 'ruler',
      zone: 'zone',
    };
    return options[type];
  };

  renderIconText = (locale, type, value) => {
    let iconText = '';

    switch (type) {
      case 'beds':
        iconText = this.bedIconText(value);
        break;
      case 'sqft':
        iconText = this.sqftIconText(value);
        break;
      case 'zone':
        iconText = locale == 'london' ? this.zoneIconText(value) : value;
        break;
    }
    return iconText;
  };

  bedIconText = (beds) =>
    beds == 0 ? I18n.t('home_points.studio') : I18n.t('home_points.bedrooms', (beds = { beds }));

  sqftIconText = (sqft) => I18n.t('home_points.sqft', (sqft = { sqft }));

  zoneIconText = (zone) => I18n.t('home_points.zone', (zone = { zone }));

  renderFeature = (locale, type, value, image) => {
    const hasValidBedroomVal = type === 'beds' && value >= 0;

    if (!hasValidBedroomVal && !value) {
      return null;
    }

    return (
      <div className={`home-points__point home-points__point-${type}`}>
        <img
          className={`home-points__point-image home-points__point-image--${this.selectFeatureIconClass(type)}`}
          src={image}
        />
        {this.renderIconText(locale, type, value)}
      </div>
    );
  };

  render() {
    const { bedrooms, sqft, zone, neighbourhood, locale } = this.props.listing;
    return (
      <div className="home-points">
        {this.renderFeature(locale, 'beds', bedrooms, IconBeds)}
        {sqft ? this.renderFeature(locale, 'sqft', sqft, IconSqft) : null}
        {locale === 'london'
          ? this.renderFeature(locale, 'zone', zone, IconZone)
          : this.renderFeature(locale, 'zone', neighbourhood, IconZone)}
      </div>
    );
  }
}
